import { render, staticRenderFns } from "./TariffsRate.vue?vue&type=template&id=d78df6ac&scoped=true&"
import script from "./TariffsRate.vue?vue&type=script&lang=js&"
export * from "./TariffsRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78df6ac",
  null
  
)

export default component.exports